<div class="standard-page-layout">
  <ng-container *ngIf="!settled">
    <app-spinner></app-spinner>
  </ng-container>

  <ng-container *ngIf="settled">
    <p id="code">{{ title }}</p>
    <p>{{ message }}</p>
  </ng-container>
</div>